// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3-TDd","rootSuccess":"CompleteLink_rootSuccess__t7CiD","rootFailure":"CompleteLink_rootFailure__2cZIl","isDisabled":"CompleteLink_isDisabled__ZEOXg"};